import { DividerProps, default as MuiDivider } from '@mui/material/Divider'
import * as React from 'react'

const Divider: React.FC<React.PropsWithChildren<DividerProps>> = (props) => {
  return <MuiDivider {...props} />
}

export default Divider
